export const DOMParser = globalThis.DOMParser
